import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  uploadDialog: {
    height: 285,
    width: 355,
  },
  radioButton: {
    color: `#000 !important`,
    '& checked': {
      color: `#000 !important`,
    },
  },
}));
